import React from 'react';
import { getFileName } from 'utils/getFileName';
import Button from '../Button';
import clsx from 'clsx';

const ImageViewer = ({ label, onClick, value, customButton }) => {
  return (
    <div className="image-viewer">
      {label && <p className="image-viewer-title">{label}</p>}
      <div className={clsx('image-viewer-field', !value && 'empty')} style={{ margin: 0 }}>
        {!value ? (
          <div className="image-viewer-empty-image">
            <img src="/assets/image/no-image-available.png" className="img" />
            <p style={{ color: '#757575', marginTop: 8 }}>Belum Ada Foto</p>
          </div>
        ) : (
          <img src={value} className="image-viewer-image" alt={value} />
        )}
        {value ? (
          customButton ? (
            <div className="image-viewer-btn">{customButton}</div>
          ) : getFileName(value) !== '' ? (
            <Button className="image-viewer-btn" onClick={() => onClick(value)}>
              Lihat Foto
            </Button>
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default ImageViewer;
